import { Action } from 'redux';

import { SortDirections } from '@shared/constants/SortDirections';
import { PatientSortingFields } from '@shared/constants/sortingFields';
import {
  ChangePatientsSortingPayload,
  PatientSharedWithChangedPayload,
  SetActivePatientListTabPayload,
} from '@shared/redux/actions/payloadTypes/patientActionPayloads';
import { ActionWithPayload } from '@shared/redux/actions/typings';
import { SearchQueryState } from '@shared/redux/state/patients';
import { PatientListTabIds } from '@shared/types/patientListTypes';

export const REMOVE_PATIENT_SUCCESS = 'REMOVE_PATIENT_SUCCESS';

export const SET_ACTIVE_PATIENT_LIST_TAB = 'SET_ACTIVE_PATIENT_LIST_TAB';

export const SDB_CHANGE_PATIENTS_SORTING = 'SDB_CHANGE_PATIENTS_SORTING';
export const VENTILATION_CHANGE_PATIENTS_SORTING = 'VENTILATION_CHANGE_PATIENTS_SORTING';

export const PATIENT_SHARED_WITH_CHANGED = 'PATIENT_SHARED_WITH_CHANGED';

export const SDB_TOGGLE_PATIENT_EXPANSION = 'SDB_TOGGLE_PATIENT_EXPANSION';

export const VENTILATION_TOGGLE_PATIENT_EXPANSION = 'VENTILATION_TOGGLE_PATIENT_EXPANSION';

export const LOCK_PATIENT_FORM = 'LOCK_PATIENT_FORM';
export const UNLOCK_PATIENT_FORM = 'UNLOCK_PATIENT_FORM';

export const SET_PATIENTS_SEARCH_QUERY = 'SET_PATIENTS_SEARCH_QUERY';

export const TOGGLE_SCHEDULED_PATIENTS_EXPANSION = 'TOGGLE_SCHEDULED_PATIENTS_EXPANSION';

export const removePatientSuccess = () => ({
  type: REMOVE_PATIENT_SUCCESS,
  successNotification: { resourceKey: 'Notification_Patient_Deleted' },
});

export const setPatientsSearchQuery = (searchQuery: SearchQueryState) => ({
  type: SET_PATIENTS_SEARCH_QUERY as typeof SET_PATIENTS_SEARCH_QUERY,
  payload: { searchQuery },
});

export const toggleScheduledPatientsExpansion = (activeTab: PatientListTabIds | null, expanded: boolean) => ({
  type: TOGGLE_SCHEDULED_PATIENTS_EXPANSION as typeof TOGGLE_SCHEDULED_PATIENTS_EXPANSION,
  payload: {
    activeTab,
    expanded,
  },
});

export const toggleSdbPatientExpansion = (patientRowKey: string | null) => ({
  type: SDB_TOGGLE_PATIENT_EXPANSION as typeof SDB_TOGGLE_PATIENT_EXPANSION,
  payload: { patientRowKey },
});

export const toggleVentilationPatientExpansion = (patientRowKey: string | null) => ({
  type: VENTILATION_TOGGLE_PATIENT_EXPANSION as typeof VENTILATION_TOGGLE_PATIENT_EXPANSION,
  payload: { patientRowKey },
});

export const sdbChangePatientSorting = (
  field: PatientSortingFields,
  defaultSortDirection?: SortDirections,
): ActionWithPayload<ChangePatientsSortingPayload> => ({
  type: SDB_CHANGE_PATIENTS_SORTING,
  payload: { field, defaultSortDirection },
});

export const ventilationChangePatientSorting = (
  field: PatientSortingFields,
  defaultSortDirection?: SortDirections,
): ActionWithPayload<ChangePatientsSortingPayload> => ({
  type: VENTILATION_CHANGE_PATIENTS_SORTING,
  payload: { field, defaultSortDirection },
});

export const setPatientsActiveTab = (tabId: PatientListTabIds) => ({
  type: SET_ACTIVE_PATIENT_LIST_TAB as typeof SET_ACTIVE_PATIENT_LIST_TAB,
  payload: { tabId },
});

export type SetActivePatientListTab = ActionWithPayload<
  SetActivePatientListTabPayload,
  typeof SET_ACTIVE_PATIENT_LIST_TAB
>;

export type PatientSharedWithChangedAction = ActionWithPayload<
  PatientSharedWithChangedPayload,
  typeof PATIENT_SHARED_WITH_CHANGED
>;

export type LockPatientFormAction = Action<typeof LOCK_PATIENT_FORM>;
export type UnlockPatientFormAction = Action<typeof UNLOCK_PATIENT_FORM>;

export type SetPatientsSearchQuery = ReturnType<typeof setPatientsSearchQuery>;
export type ToggleScheduledPatientsExpansionAction = ReturnType<typeof toggleScheduledPatientsExpansion>;
export type SdbTogglePatientExpansionAction = ReturnType<typeof toggleSdbPatientExpansion>;
export type VentilationTogglePatientExpansionAction = ReturnType<typeof toggleVentilationPatientExpansion>;

export type PatientActions =
  | PatientSharedWithChangedAction
  | SetPatientsSearchQuery
  | LockPatientFormAction
  | UnlockPatientFormAction
  | SdbTogglePatientExpansionAction
  | VentilationTogglePatientExpansionAction
  | SetActivePatientListTab
  | ToggleScheduledPatientsExpansionAction;
